import EventEmitter from 'events'

import store from '@/store/store.js'
import axios from '../http/axios/index.js'
import jwtDecode from 'jwt-decode'
import router from '../router'

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
const localStorageKey = 'loggedIn'

const tokenExpiryKey = 'tokenExpiry'
const loginEvent = 'loginEvent'

class AuthService extends EventEmitter {
  isAuthenticated() {
    try {
      let token = localStorage.getItem('accessToken')
      // if token null return false
      if (token) {
        const now = Date.now().valueOf() / 1000
        const decoded = jwtDecode(token)

        if (!(typeof decoded.exp !== 'undefined' && decoded.exp < now)) {
          return true
        }
      }
    } catch (error) {}

    return false
  }

  validRefreshToken() {
    try {
      let token = localStorage.getItem('refreshToken')
      // if token null return false
      if (token) {
        const now = Date.now().valueOf() / 1000
        const decoded = jwtDecode(token)

        if (!(typeof decoded.exp !== 'undefined' && decoded.exp < now)) {
          return true
        }
      }
    } catch (error) {}

    return false
  }

  purgeStorage() {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('userInfo')
  }
  // TODO: implement renewing our tokens here.
  renewTokens() {
    // this is called on app-load to refresh a token if we have one
    if (!this.validRefreshToken()) {
     return
    }
    // signal axios to set the token
    let token = localStorage.getItem('accessToken')
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }
}

export default new AuthService()
